// shared/domain/descarga.js  (reglas puras para descargas de archivos). Sin DOM ni red.

const safeDecode = value => {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return null;
  }
};

const sinComillas = value =>
  value
    .trim()
    .replace(/^"(.*)"$/, '$1')
    .trim();

/**
 * Nombre de archivo desde el header Content-Disposition.
 * Soporta `filename=x.pdf`, `filename="x.pdf"` y `filename*=UTF-8''x%20y.pdf` (prefiere filename*).
 * Devuelve `fallback` si falta o es inválido.
 */
export const nombreArchivoDesdeContentDisposition = (header, fallback) => {
  if (!header || typeof header !== 'string') return fallback;
  const extendido = /filename\*\s*=\s*([^;]+)/i.exec(header);
  if (extendido) {
    const valor = sinComillas(extendido[1]);
    const sinCharset = valor.replace(/^[^']*'[^']*'/, '');
    const decodificado = safeDecode(sinCharset);
    if (decodificado && decodificado.trim()) return decodificado.trim();
  }
  const simple = /filename\s*=\s*("[^"]*"|[^;]+)/i.exec(header.replace(/filename\*\s*=\s*[^;]+;?/gi, ''));
  if (simple) {
    const valor = sinComillas(simple[1]);
    if (valor) return valor;
  }
  return fallback;
};

/** Mensaje para HTTP 429 (límite de PDFs). `segundos` viene de Retry-After; sin valor válido, "en un momento". */
export const mensajeLimitePdf = segundos => {
  const n = Number(segundos);
  const cuando = Number.isFinite(n) && n > 0 ? `en ${Math.ceil(n)} segundos` : 'en un momento';
  return `Has generado muchos PDF en poco tiempo. Intenta de nuevo ${cuando}.`;
};
